<hum-icon [icon]="icon" class="icon"></hum-icon>
<div class="name">{{name}}</div>